import { ActionMenuItem } from '@shared/components/action-menu/action-menu-item.model';
import { CHECK_PERMISSIONS } from '@shared/modules/permissions.module';
import { InterventionActions } from './intervention-actions-enum';

export const useInterventionActionMenu = () => {
  // Composable logic for navigation menu can be added here
  const validatePermission = CHECK_PERMISSIONS();
  const interventionActionMenuItems: ActionMenuItem[] = [
    {
        title:'Details',
        icon:'info',
        route:'/interventions',
        validPermission: validatePermission.canReadInterventions(),
        action: InterventionActions.PageChange,
    },
  ];
  return{
    interventionActionMenuItems
  }
};
